import { Component, OnInit, EventEmitter,Input, Output } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Producto } from '../../../models/producto';
import { TipoPrecioService } from '../../../services/tipo-precio.service';
import { TipoPrecio } from '../../../models/tipo_precio';
import { SessionService } from '../../../services/session.service';
import { PrecioAdicionalService } from '../../../services/precio-adicional.service';
import { PrecioAdicional } from '../../../models/precio_adicional';
import { EditarPrecioModalComponent } from '../../modals/editar-precio-modal/editar-precio-modal.component';
import { SweetMessage } from '../../../config/sweet-message';
import { Validation } from '../../../config/validation';

@Component({
  selector: 'app-precio-adicional-modal',
  templateUrl: './precio-adicional-modal.component.html',
  styleUrls: ['./precio-adicional-modal.component.css'],
  providers: [
	TipoPrecioService,
	SessionService,
	PrecioAdicionalService
  ]
})
export class PrecioAdicionalModalComponent implements OnInit {
	@Input() producto: Producto;
	@Input() numero_decimales: number = 2;
	@Input() tipos_id: String;
	@Output() sendPrecioAdicional = new EventEmitter();
	public PrecioAdd: PrecioAdicional;
	public valor: number;
	public precios: Array<PrecioAdicional>;
	public adicionales: Array<TipoPrecio>;
	public tipos: Array<TipoPrecio>;
	public tipo: TipoPrecio;
	public tipo_aux: TipoPrecio;
	// public editar: boolean;
	public loading: boolean;
	public msgSweet: SweetMessage;
	public vl: Validation;
	public format_decimal: String;
	public is_editable: boolean;
	constructor(
		public bsModalRef: BsModalRef,
		public bsModalRef2: BsModalRef,
		public tipoprecioService: TipoPrecioService,
		public ss: SessionService,
		public pAdicionalService: PrecioAdicionalService,
		private modalService: BsModalService,
	) { 
		this.PrecioAdd = new PrecioAdicional();
		this.valor = 0;
		this.precios = [];
		this.adicionales = [];
		this.loading = false;
		this.tipos = [];
		this.tipo = new TipoPrecio();
		this.tipo_aux = null;
		// this.editar = false;
		this.msgSweet = new SweetMessage();
		this.vl = new Validation();
		this.is_editable = false;
	}

	ngOnInit() {
		
		let digitos = "";
		for(let i = 0; i < this.numero_decimales; i++) digitos += "0";
		this.format_decimal = "0,0." + digitos

		let p1 = this.getPrecios();
		let p2 = this.getTipos();
        this.loading = true;

        Promise.all([p1,p2]).then(
            res => this.loading = false,
            err => this.loading = false
        );
	}

	onChangeTipo(){
		
		this.tipo = this.tipo_aux;
		
	}

	getPrecios(){
		return new Promise((resolve, reject) => {
			let qs = "?producto_id="+ this.producto.id+"&status=A&embed=tipoPrecio";
			this.pAdicionalService.getAll(qs).subscribe(
				res => {
					this.adicionales = res.data
					resolve();
				},
				err => {
					this.adicionales = [];
					reject(err);
				}
			);
		});
	}

	getTipos(){
		return new Promise((resolve, reject) => {
			this.tipoprecioService.getAll("?notin[id]=" + this.tipos_id).subscribe(
				res => {
					this.tipos = res.data;
					resolve();
				},
				err => {
					reject(err);
				}
			);
		});
	}

	setValueEntity(){
		this.PrecioAdd.valor = this.valor;
		this.PrecioAdd.producto_id = this.producto.id;
		this.PrecioAdd.tipo_precio_id = this.tipo.id;
		this.PrecioAdd.tipo_precio = this.tipo;
		this.PrecioAdd.usuario_id = this.ss.getData('usuario_id');
	}

	onSubmit(){
		this.setValueEntity();
		this.sendPrecioAdicional.emit(this.PrecioAdd);
		this.bsModalRef.hide();
		// this.setValueEntity();
		// this.loading = true;
		// this.pAdicionalService.save(this.PrecioAdd).subscribe(
		// 	res => {
		// 		this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente');
		// 		this.loading = false;
		// 		this.PrecioAdd = new PrecioAdicional();
		// 		this.adicionales = [];
		// 		this.precios = [];
		// 		this.valor = 0;
		// 		this.getPrecios();
		// 	},
		// 	err => {
		// 		this.loading = false;
        //         this.msgSweet.showMessage('error-message',err);
		// 	}
		// );


	}

	// onEditar(adicional){
	// 	adicional.editar = !adicional.editar;
	// 	this.is_editable = !this.is_editable;
	// 	// const initialState = { precioAdd: adicional, Respuesta: false};
    //     // this.bsModalRef2 = this.modalService.show(EditarPrecioModalComponent, Object.assign({backdrop: 'static'}, {class: 'modal-sm', initialState}));

	// 	// this.bsModalRef2.content.action.take(1).subscribe((Respuesta) => {
    //     //     if(Respuesta == true){
    //     //         this.getPrecios();
    //     //     }
    //     // });
	// }

	// onEliminar(id){
	// 	this.loading = true;
	// 	this.pAdicionalService.delete(id).subscribe(
	// 		res => {
	// 			this.loading = false;
	// 			this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente');
	// 			this.getPrecios();
	// 		},
	// 		err => {
	// 			this.loading = false;
    //             this.msgSweet.showMessage('error-message',err);
	// 		}
	// 	);
	// }

	isValidForm(){
		if(!this.tipo.id){
			return false;
		}
		if(this.valor <= 0 ){
			return false;
		}
		return true;
	}

	get formatDecimal(){
        return this.format_decimal;
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/precio-adicional-modal/precio-adicional-modal.component.ts